module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAMJJREFUWAntmM0JwzAUg/NaU+g+2aCHrpFDx8oaPXSIzlMI/cOX4hSCLBIfBMrJ4QlbfLLh2XEap0+n8CkYzR53CjCzRxmjqYboeXw03ce3yzGQDxmiNoqiZOsmyhJDehNFhNi6ibLEkN5EESG2bqIsMaQ3UUSIrVf1ozX9Irswq5eJfpEo6upT2vfX4XDPZFppS+oyRG20jG2LsYluQbGcY/HUR8SrFP6Pn+/ud9dvpZ2t6benGY71PzKHKRSiz3l8AVUxMWfjuC8kAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/mixers/QuickSelection-02.png
// module id = 1072
// module chunks = 2